<template lang="pug">
  .ok-cancel-modal
    b-modal(v-model="_value" :size="size" hide-header @ok="ok" @cancel="cancel" no-close-on-backdrop no-close-on-esc)
      .default-modal-body
        .d-flex.flex-wrap.justify-content-center
          b-time(v-model="_time" :minutes-step="minutesStep" label-no-time-selected="未入力")

      template(#modal-footer="{ ok, cancel }")
        b-button.btn.modal-ok-btn(@click="ok") {{ okButtonLabel }}
        b-button.btn.modal-cancel-btn(@click="cancel") {{ cancelButtonLabel }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 時間入力モーダル
 */
@Component
export default class TimePickerModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;
  /** 時間 */
  @Prop({ required: true })
  time!: string;
  /** 時間の上昇値 */
  @Prop({ default: () => 5 })
  minutesStep!: number;
  /** モーダルサイズ */
  @Prop({ default: () => "sm" })
  size!: string;
  /** OKボタンラベル */
  @Prop({ default: () => "OK" })
  okButtonLabel!: string;
  /** キャンセルボタンラベル */
  @Prop({ default: () => "キャンセル" })
  cancelButtonLabel!: string;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _time(): string {
    return this.time;
  }

  set _time(newValue: string) {
    this.$emit("update:time", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  public cancel(): void {
    this.$emit("cancel");
    return;
  }
}
</script>
